export const LayoutBlockDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type LayoutBlockDirection =
  (typeof LayoutBlockDirection)[keyof typeof LayoutBlockDirection]

export const LayoutBlockJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type LayoutBlockJustifyContent =
  (typeof LayoutBlockJustifyContent)[keyof typeof LayoutBlockJustifyContent]

export const LayoutBlockAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type LayoutBlockAlignItems =
  (typeof LayoutBlockAlignItems)[keyof typeof LayoutBlockAlignItems]
